import { types } from 'mobx-state-tree';

const MAX_WAIT_DURATION = 4000;

const ProgressStore = types
  .model('Progress', {
    loading: types.boolean,
    mediaLoaded: types.optional(types.boolean, true),
  })
  .actions(self => {
    let loadingMediaCount = 0;
    let mediaListeners = [];

    return {
      turnOn: () => {
        if (self.loading) {
          return;
        }

        self.loading = true;
      },

      turnOff: () => {
        if (!self.loading) {
          return;
        }

        self.loading = false;
      },

      registerMedia: () => {
        self.mediaLoaded = false;
        loadingMediaCount += 1;
      },

      onMediaLoad: () => {
        loadingMediaCount -= 1;
        if (loadingMediaCount === 0) {
          self.mediaLoaded = true;
          self.runListeners();
        }
      },

      addMediaLoadedListener: cb => {
        if (self.mediaLoaded) {
          cb();
          return;
        }

        mediaListeners.push(cb);
        setTimeout(() => {
          const listener = mediaListeners.filter(v => v === cb)[0];
          if (listener) {
            mediaListeners = mediaListeners.filter(v => v !== cb);
            listener();
          }
        }, MAX_WAIT_DURATION);
      },

      runListeners: () => {
        mediaListeners.forEach(cb => cb());
        mediaListeners = [];
      },
    };
  });

export default ProgressStore;



// WEBPACK FOOTER //
// ./src/stores/ProgressStore.js